import React from 'react';
import {KPI} from '../../kpi';
import GeneralSelectorTableStore, {SelectorTableColumnDefScoreAttributes} from '../../stores/GeneralSelectorTableStore';
import {observer} from 'mobx-react';
import {TableSortDirection} from '../../types/Table';
import {I18n, MessageProvider, TProvider} from '../../i18n/i18n';
import {px} from 'csx';

interface AdvancedSortingMenuProps {
    selectorTableStore: GeneralSelectorTableStore;
}

export default class AdvancedSortingMenu extends React.Component<AdvancedSortingMenuProps> {
    public render() {
        const {selectorTableStore} = this.props;
        return (
            <div style={{marginTop: 5}}>
                <div
                    style={{
                        fontSize: px(10),
                        fontWeight: 'bold',
                        marginBottom: 2,
                    }}>
                    <I18n i18nKey="table:advancedSorting" />
                </div>
                <div
                    style={{
                        fontSize: px(12),
                        paddingBottom: 5,
                    }}>
                    <div style={{float: 'left', verticalAlign: 'top'}}>
                        <I18n i18nKey="table:slope" />
                    </div>
                    <div style={{float: 'right', verticalAlign: 'top'}}>
                        <AdvancedSortingDropdown
                            attribute={selectorTableStore.tableHeaderFilterMenu.attribute}
                            selectorTableStore={selectorTableStore}
                            type="slope"
                        />
                    </div>
                    <div className="clearfix" />
                </div>
                <div
                    style={{
                        fontSize: px(12),
                    }}>
                    <div style={{float: 'left', verticalAlign: 'top'}}>
                        <I18n i18nKey="table:outlier" />
                    </div>
                    <div style={{float: 'right', verticalAlign: 'top'}}>
                        <AdvancedSortingDropdown
                            attribute={selectorTableStore.tableHeaderFilterMenu.attribute}
                            selectorTableStore={selectorTableStore}
                            type="outlier"
                        />
                    </div>
                    <div className="clearfix" />
                </div>
            </div>
        );
    }
}

interface AdvancedSortingDropdownProps {
    attribute: KPI;
    selectorTableStore: GeneralSelectorTableStore;
    type: keyof SelectorTableColumnDefScoreAttributes | 'min';
}

@observer
class AdvancedSortingDropdown extends React.Component<AdvancedSortingDropdownProps> {
    /**
     * Min scores are below 1 and get more important, the lower they get. The sort direction will be
     * switched, so that desc all the lower scores get sorted first
     * @param sortDirection
     * @returns {*}
     */
    public invertSortDirectionForMinValues(sortDirection: TableSortDirection): TableSortDirection {
        if (this.props.type === 'min') {
            switch (sortDirection) {
                case TableSortDirection.DESC:
                    return TableSortDirection.ASC;
                case TableSortDirection.ASC:
                    return TableSortDirection.DESC;
                default:
                    return sortDirection;
            }
        }
        return sortDirection;
    }

    public onIrregularityDropdownChanged = (e: React.ChangeEvent<HTMLSelectElement>): void => {
        const {selectorTableStore} = this.props;
        const sortDirection = e.currentTarget.value as TableSortDirection;
        let type = this.props.type;

        if (type === 'min') {
            return;
        }

        if (type === 'slope') {
            if (sortDirection === TableSortDirection.ASC) {
                type = 'minSlope';
            } else if (sortDirection === TableSortDirection.DESC) {
                type = 'maxSlope';
            }
        }

        const scoreAttribute = selectorTableStore.getScoreAttribute(this.props.attribute, type);
        selectorTableStore.setDirectTableSort(scoreAttribute, sortDirection);
    };

    public getValueForAttribute(): string {
        const {selectorTableStore} = this.props;
        const {sortDirection, attribute} = selectorTableStore.tableSorting;
        let scoreAttribute;
        let sortOrder;
        if (this.props.type === 'outlier') {
            scoreAttribute = selectorTableStore.getScoreAttribute(this.props.attribute, this.props.type);
            sortOrder = this.invertSortDirectionForMinValues(sortDirection);
        } else {
            const type = sortDirection === TableSortDirection.DESC ? 'maxSlope' : 'minSlope';
            scoreAttribute = selectorTableStore.getScoreAttribute(this.props.attribute, type);
            sortOrder = sortDirection;
        }
        return attribute === scoreAttribute ? sortOrder : '';
    }

    public getDropdownValues(t: MessageProvider): string[][] {
        switch (this.props.type) {
            case 'slope':
            case 'outlier':
                return [
                    ['', ''],
                    [TableSortDirection.ASC, t('table:ascending')],
                    [TableSortDirection.DESC, t('table:descending')],
                ];
            default:
                return [['', '']];
        }
    }

    public generateOptions(t: MessageProvider): React.ReactNode {
        const values = this.getDropdownValues(t);
        return values.map((data) => {
            return (
                <option key={data[0]} value={data[0]}>
                    {data[1]}
                </option>
            );
        });
    }

    public render(): React.ReactNode {
        const {selectorTableStore} = this.props;
        selectorTableStore.showLoadingHover;
        selectorTableStore.updateTable;
        return (
            <div>
                <TProvider>
                    {(t) => (
                        <select style={{width: 65}} value={this.getValueForAttribute()} onChange={this.onIrregularityDropdownChanged}>
                            {this.generateOptions(t)}
                        </select>
                    )}
                </TProvider>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Table/AdvancedSortingMenu.tsx